/* LithiumPro – del 2 af designsystemets scripts (runde 2) */
(function () {
  'use strict';
  var d = document, w = window;

  /* Produktside: tilvalgslisten viser de første 3 – resten foldes ud med én knap.
     Markerede tilvalg skjules aldrig. */
  function initUpsellMore() {
    if (!/template-product/.test(d.body.className)) return;
    var box = d.querySelector('.m6pr .f8pr-bulk');
    if (!box) return;
    var ul = box.querySelector(':scope > ul');
    if (!ul) return;
    var items = Array.prototype.filter.call(ul.children, function (li) { return li.tagName === 'LI'; });
    var MAX = 3;
    if (items.length <= MAX + 1) return;
    var rest = items.slice(MAX);
    var checked = rest.some(function (li) { var c = li.querySelector('input[type="checkbox"]'); return c && c.checked; });
    if (checked) return;
    rest.forEach(function (li) { li.classList.add('lp-up-hidden'); });
    var btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'lp-up-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>Vis alle tilvalg (' + items.length + ')</span><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    btn.addEventListener('click', function () {
      rest.forEach(function (li) { li.classList.remove('lp-up-hidden'); });
      btn.setAttribute('aria-expanded', 'true');
      btn.parentNode.removeChild(btn);
      var first = rest[0] && rest[0].querySelector('input, a');
      if (first && first.focus) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    });
    ul.parentNode.insertBefore(btn, ul.nextSibling);
  }


  /* Kurv: en automatisk rabat, der rammer en anden linje, viser "(-0,00 kr)" på linjer uden rabat.
     Det forvirrer – så skjuler vi etiketter, hvor rabatten er 0. Kører igen, når kurven opdateres. */
  function hideZeroDiscounts(root) {
    var scope = root && root.querySelectorAll ? root : d;
    var els = scope.querySelectorAll('.l4ca p.overlay-gray, .form-cart p.overlay-gray, #cart p.overlay-gray, aside#cart p.overlay-gray');
    Array.prototype.forEach.call(els, function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ');
      if (/[-−]\s?0(?:,00)?\s?kr/.test(t) && !/[-−]\s?[1-9]/.test(t)) el.style.setProperty('display', 'none', 'important');
    });
  }
  var zeroTimer = null;
  function watchCart() {
    hideZeroDiscounts();
    if (!w.MutationObserver) return;
    new MutationObserver(function () {
      clearTimeout(zeroTimer);
      zeroTimer = setTimeout(function () { hideZeroDiscounts(); try { initEta(); } catch (e) {} }, 80);
    }).observe(d.body, { childList: true, subtree: true });
  }


  /* Produktside + kurv: konkret leveringsdato ud fra "2-4 hverdage" (weekender springes over). */
  var LANG2 = (d.documentElement.lang || 'da').slice(0, 2);
  function addBiz(from, n) { var x = new Date(from); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function fmtDate(x) {
    if (LANG2 === 'en') { var de = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], me = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; return de[x.getDay()] + ' ' + x.getDate() + ' ' + me[x.getMonth()]; }
    var dd = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'], mm = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    return dd[x.getDay()] + '. ' + x.getDate() + '. ' + mm[x.getMonth()] + '.';
  }
  function etaText() {
    if (LANG2 !== 'da' && LANG2 !== 'en') return '';
    var now = new Date(), a = addBiz(now, 2), b = addBiz(now, 4);
    return (LANG2 === 'en' ? 'Estimated delivery ' : 'Forventet levering ') + fmtDate(a) + ' – ' + fmtDate(b);
  }
  function initEta() {
    var t = etaText(); if (!t) return;
    /* Produktside: under "2-4 dages levering" */
    d.querySelectorAll('#main-product .f8pr-stock p.stock').forEach(function (p) {
      if (p.querySelector('.lp-eta') || !/2[-–]4/.test(p.textContent)) return;
      var s = d.createElement('span'); s.className = 'lp-eta'; s.textContent = t; p.appendChild(s);
    });
    /* Kurvsiden: USP-linjen "Levering på 2-4 hverdage" */
    d.querySelectorAll('.form-cart ul.l4us li').forEach(function (li) {
      if (li.querySelector('.lp-eta') || !/2[-–]4/.test(li.textContent)) return;
      var s = d.createElement('span'); s.className = 'lp-eta'; s.textContent = t; li.appendChild(s);
    });
  }

  /* Produktside: lille Trustpilot-linje under titlen (butikkens samlede bedømmelse, ikke produktanmeldelser). */
  function initTrust() {
    if (!/template-product/.test(d.body.className)) return;
    d.querySelectorAll('#main-product header > h1, #main-product header > h2').forEach(function (h) {
      if (h.parentNode.querySelector('.lp-tp')) return;
      var a = d.createElement('a');
      a.className = 'lp-tp'; a.href = 'https://dk.trustpilot.com/review/lithiumpro.dk'; a.target = '_blank'; a.rel = 'noopener';
      a.innerHTML = '<span class="lp-tp__s" aria-hidden="true">★★★★★</span><span>4,8 på Trustpilot</span>';
      h.insertAdjacentElement('afterend', a);
    });
  }

  /* Mobilmenu: ikon til menupunkter uden kollektionsbillede (solcelleguide og hjælp).
     Lægges ind som <img> i temaets egen billedramme, så temaet viser/skjuler det præcis som de andre billeder. */
  function tile(bg, stroke, paths) {
    return 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">' + bg +
      '<g transform="translate(6.5 6.5) scale(.7083)" fill="none" stroke="' + stroke + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + paths + '</g></svg>');
  }
  var MENU_ICONS = {
    '/pages/solcelleguide': tile('<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f59e0b"/><stop offset="1" stop-color="#d97706"/></linearGradient></defs><rect width="30" height="30" rx="7" fill="url(#g)"/>', '#fff',
      '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>'),
    '/pages/faq': tile('<rect x=".5" y=".5" width="29" height="29" rx="6.5" fill="#fff" stroke="#000" stroke-opacity=".1"/>', '#0d0d0f',
      '<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>')
  };
  function initMenuIcons() {
    d.querySelectorAll('#nav > ul[data-type="main-nav"] > li > a:not(.toggle)').forEach(function (a) {
      if (a.querySelector('span.img')) return;
      var href = (a.getAttribute('href') || '').replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/pages\/)/i, '');
      var src = MENU_ICONS[href]; if (!src) return;
      var s = d.createElement('span');
      s.className = 'img category lp-mimg';
      s.innerHTML = '<picture><img src="' + src + '" alt="" width="30" height="30"></picture>';
      a.insertBefore(s, a.firstChild);
    });
  }

  function init() {
    try { initEta(); } catch (e) { if (w.console) console.warn('lp eta', e); }
    try { initTrust(); } catch (e) { if (w.console) console.warn('lp trust', e); }
    try { watchCart(); } catch (e) { if (w.console) console.warn('lp zero', e); }
    try { initUpsellMore(); } catch (e) { if (w.console) console.warn('lp upsell', e); }
    try { initMenuIcons(); setTimeout(initMenuIcons, 1500); } catch (e) { if (w.console) console.warn('lp menu', e); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
